<div class="search-account">
  <div class="flex-body justify-content-between">
    <div class="flex-body">
      <div class="p-inputgroup m-r-12" *ngIf="tableMeta.showAccountSearch">
        <p-autoComplete *ngIf="!(tableMeta.isCustomerUser)" class="m-r-12" type="search" [suggestions]="accounts"
          (completeMethod)="fillAccounts()" [field]="customField" [size]="30" (onSelect)="onSelectAccount($event)"
          [(ngModel)]="accountSearch" [minLength]="3" placeholder="{{'vbeiAccountsSearchText' | translate}}"
          (onClear)="resetProductCategoryTable()" appendTo="body">
        </p-autoComplete>
        <p-dropdown filter="true" *ngIf="tableMeta.isCustomerUser" class="m-r-12 width-inherit" [options]="accounts"
          filterPlaceholder="{{'vbeiAccountsSearchText' | translate}}" optionLabel="custom" placeholder="{{'vbeiSelect' | translate}}"
          (onChange)="accountSelected()" showClear="true" [(ngModel)]="dropDownAccountSelected"
          emptyFilterMessage="{{'vbeiAccountsNotFound' | translate}}" appendTo="body">
        </p-dropdown>
      </div>
      <div class="p-inputgroup m-r-12" *ngIf="tableMeta.displayGlobalSearch" [appClearInput]="gridTable" (resetInput)="searchText = ''" [searchText]="searchText">
        <span class="p-inputgroup-addon"><i class="ei ei-magnifier"></i></span>
        <input [disabled]="disableGrid" class="p-inputtext" type="text" pInputText size="50" [(ngModel)]="searchText"
          placeholder="{{placeHolderText}}" (input)="gridTable.filterGlobal($event.target.value, 'contains')" />
      </div>
      <div class="m-r-12" *ngIf="tableMeta.displayGlobalFilter">
        <p-splitButton label="{{'vbeiFilter' | translate}}" (onClick)="sendGlobalFilterDataToParent()" [model]="globalFilterOptions">
        </p-splitButton>
      </div>
      <div class="m-r-12" *ngIf="tableMeta.displayGlobalDropdown">
        <p-dropdown [options]="globalDropdownOptions" placeholder="{{'vbeiSelect' | translate}}" optionLabel="name" optionValue="code"
          (onChange)="sendGlobalDropdownDataToParent($event)" appendTo="body" [baseZIndex]="11500"></p-dropdown>
      </div>
      <div>
        <div class="p-button" *ngIf="tableMeta.displayDownloadButton">
          <button pTooltip="{{exportToolTip}}" [disabled]="disableImportExport" pButton icon="ei-download2"
            (click)="downloadWindow()"></button>
        </div>
        <div style="padding-left: 10px;" class="p-button" *ngIf="tableMeta.displayUploadButton">
          <button pTooltip="{{importToolTip}}" [disabled]="disableImportExport" pButton icon="ei-upload2"
            (click)="uploadWindow()"></button>
        </div>
      </div>
    </div>
    <div>
      <button class="p-button m-r-12" *ngIf="tableMeta.displayCreateButton" pButton (click)="onCreateButtonClick()"
        type="button" icon="ei ei-plus" iconPos="left" label="{{createButtonText}}"></button>
      <button class="p-button p-button-secondary" *ngIf="tableMeta.displayExtraCreateButton" pButton
        (click)="onExtraCreateButtonClick()" type="button" icon="ei ei-refresh" iconPos="left"
        label="{{extraCreateButtonText}}"></button>
    </div>
  </div>
</div>
<div class="invalid-msg" *ngIf="!isAccountExist">
  {{'vbeiAccountsNotFound' | translate}}
</div>
<div>
  <!-- Enable context menu: Add code to tr [contextMenu]="gridContext" -->
  <p-table #gridTable [columns]="columnsMeta" [value]="gridData" [lazy]="!tableMeta.useClientSideFiltering"
    [scrollable]="true" [style]="{width:'100%'}" (onLazyLoad)="lazyLoadData($event)" [(selection)]="selectedTableRows"
    [totalRecords]="totalRecords" sortField="{{defaultSortColumn}}" [sortOrder]="sortOrder"
    [ngClass]="{'hide-summary': selectedTableRows?.length == 0 || !tableMeta.displaySummary}">
    <ng-template pTemplate="colgroup" let-columns>
      <colgroup>
        <col style="width:52px" *ngIf="tableMeta.displayCheckBox">
        <ng-template ngFor let-col [ngForOf]="columns">
          <col width="{{(col.width) ? col.width : '200px'}}">
        </ng-template>
        <col style="width:100px" *ngIf="tableMeta.displayKebabMenu">
        <col style="width:52px" *ngIf="tableMeta.displaySplitMenu">
      </colgroup>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th style="width: 52px" *ngIf="tableMeta.displayCheckBox">
          <span class="cell-content">
            <p-tableHeaderCheckbox (click)="onCheckBoxChange()"></p-tableHeaderCheckbox>
          </span>
        </th>
        <ng-template ngFor let-col [ngForOf]="columns">
          <th *ngIf="col.sortable" [pSortableColumn]="col.field" width="{{(col.width) ? col.width : ''}}"
            [ngClass]="{'mandatory': col.mandatory}">
            <span class="cell-content flex-body align-items-center">
              {{col.header}}
              <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order">
              </p-sortIcon>
            </span>
          </th>
          <th *ngIf="!col.sortable" [ngClass]="{'mandatory': col.mandatory}" width="{{(col.width) ? col.width : ''}}">
            <span class="cell-content">{{col.header}}</span>
          </th>
        </ng-template>
        <th style="width: 100px" *ngIf="tableMeta.displayKebabMenu"><span class="cell-content"></span></th>
        <th style="width: 52px" *ngIf="tableMeta.displaySplitMenu"><span class="cell-content"></span></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns">
      <!-- Enable context menu: Add code to tr [pContextMenuRow]="rowData" -->
      <tr class="hoverable">

        <td *ngIf="tableMeta.displayCheckBox">
          <p-tableCheckbox [value]="rowData" (click)="onCheckBoxChange()"></p-tableCheckbox>
        </td>

        <ng-template ngFor let-col [ngForOf]="columns">

          <td *ngIf="col.isRowSpanRequired" class="wrap-codes">
            <div [innerHTML]="resolveFieldData(rowData,col.field,false,true)[0] | highlight: searchText"></div>
            <div [innerHTML]="resolveFieldData(rowData,col.field,false,true)[1]" class="runFrequency-detail"></div>
          </td>

          <td *ngIf="col.selectable" (click)="onSelectingRow(rowData)" class="wrap-codes">
            <div class="flex-body align-center">
              <a class="anchor" [innerHTML]="resolveFieldData(rowData,col.field) | highlight: searchText"></a>
              <img *ngIf="isPending && rowData.fromSchedule" id="scheduled-order-logo" src="assets\images\0334-cart-schedule@3x.png" alt="Scheduled Order" />
            </div>
          </td>

          <td *ngIf="col.displayIcon" class="wrap-codes">
            <span>
              <i *ngIf="(rowData[col.field] == 'Yes' || rowData[col.field] == 'Enabled' || rowData[col.field] == true)"
                class="ei ei-checkmark-circle green ei-16 m-r-12"></i>
              <i *ngIf="!(rowData[col.field] == 'Yes' || rowData[col.field] == 'Enabled' || rowData[col.field] == true)"
                class="ei ei-cross-circle red ei-16 m-r-12"></i>
            </span>
            <span [innerHTML]="resolveFieldData(rowData,col.field) | highlight: searchText"></span>
          </td>

          <td *ngIf="col.displayInfoIcon" class="wrap-codes">
            <span class="flex-body align-items-center">
              <span [innerHTML]="resolveFieldData(rowData,col.field) | highlight: searchText"></span>
              <i class="ei ei-info ei-16 m-l-12"></i>
            </span>
          </td>

          <td *ngIf="col.displayYesOrNo" class="wrap-codes">
            <span>
              <i *ngIf="(rowData[col.field] == true)" class="ei ei-checkmark-circle green ei-16 m-r-12"></i>
              <span *ngIf="(rowData[col.field] == true)">{{'vbeiYes' | translate}}</span>
              <i *ngIf="!(rowData[col.field] == true)" class="ei ei-cross-circle red ei-16 m-r-12"></i>
              <span *ngIf="!(rowData[col.field] == true)">{{'vbeiNo' | translate}}</span>
            </span>

          </td>

          <td *ngIf="col.displayBadge" class="wrap-codes">
            <span class="p-badge {{resolveFieldData(rowData,col.field,true) | lowerString | lowercase}}">
              <span [innerHTML]="resolveFieldData(rowData,col.field) | highlight: searchText"></span>
              <span
                class="div-inline m-l-4 p-badge-exclamation {{resolveFieldData(rowData,col.field) | lowerString | lowercase}}"></span>
            </span>

          </td>

          <td *ngIf="col.idDefaultValue" class="wrap-codes">

            <input class="w-auto" *ngIf="rowData['fieldType'] == 'Text'" [disabled]="col.disableDefaultValueColumn"
              placeholder="{{'vbeiEnterText' | translate}}" type="text" maxlength="50" (blur)="changeDefaultValue(rowData)"
              [(ngModel)]="rowData[col.field]" appAlphanumericInput pInputText />

            <input class="w-auto" *ngIf="rowData['fieldType'] == 'Integer'" [disabled]="col.disableDefaultValueColumn"
              placeholder="{{'vbeiEnterInteger' | translate}}" type="text" maxlength="10" pKeyFilter="int"
              (blur)="changeDefaultValue(rowData)" [(ngModel)]="rowData[col.field]" appIntegerInput pInputText />

            <input class="w-auto" *ngIf="rowData['fieldType'] == 'Decimal'" [disabled]="col.disableDefaultValueColumn"
              placeholder="{{'vbeiEnterDecimal' | translate}}" type="text" (blur)="changeDefaultValue(rowData)"
              [(ngModel)]="rowData[col.field]" appDecimalInput pInputText />

            <p-dropdown class="w-auto" *ngIf="rowData['fieldType'] == 'Boolean'" appendTo="body"
              [disabled]="col.disableDefaultValueColumn" [options]="booleanTypeValues" optionLabel="label"
              placeholder="{{'vbeiSelect' | translate}}" (onChange)="changeDefaultValue(rowData)" [showClear]="true"
              [(ngModel)]="rowData[col.field]">
            </p-dropdown>

            <p-dropdown class="w-auto p-dropdown-small" *ngIf="rowData['fieldType'] == 'List'" appendTo="body"
              [disabled]="col.disableDefaultValueColumn" [options]="rowData['additionalFieldListValues']"
              optionLabel="label" placeholder="{{'vbeiSelect' | translate}}" (onChange)="changeDefaultValue(rowData)" [showClear]="true"
              [(ngModel)]="rowData[col.field]">
            </p-dropdown>

            <p-calendar class="w-auto" *ngIf="rowData['fieldType'] == 'Date Only'" appendTo="body"
              [disabled]="col.disableDefaultValueColumn" [showIcon]="true" (onBlur)="changeDefaultValue(rowData)"
              [(ngModel)]="rowData[col.field]">
            </p-calendar>

            <p-calendar class="w-auto" *ngIf="rowData['fieldType'] == 'Time Only'" appendTo="body"
              [disabled]="col.disableDefaultValueColumn" [timeOnly]="true" hourFormat="24" [showIcon]="true"
              (onBlur)="changeDefaultValue(rowData)" [(ngModel)]="rowData[col.field]">
            </p-calendar>

            <p-calendar class="w-auto" *ngIf="rowData['fieldType'] == 'Date Time'" appendTo="body"
              [disabled]="col.disableDefaultValueColumn" [showTime]="true" hourFormat="24" [monthNavigator]="true"
              [yearNavigator]="true" yearRange="2000:2030" [showIcon]="true" (onBlur)="changeDefaultValue(rowData)"
              [(ngModel)]="rowData[col.field]"></p-calendar>
          </td>

          <td
            *ngIf="!col.selectable && !col.displayIcon && !col.displayInfoIcon && !col.idDefaultValue && !col.displayYesOrNo && !col.displayBadge && !col.isRowSpanRequired"
            class="wrap-codes">
            <span [innerHTML]="resolveFieldData(rowData,col.field) | highlight: searchText"></span>
          </td>

        </ng-template>

        <td *ngIf="tableMeta.displayKebabMenu">
          <div class="table-fields-option m-b-auto" *ngIf="!showLoadingKebab">
            <a class="div-inline no-text-decoration pull-right hide-on-hover">
              <i class="ei ei-kebab-more ei-16"></i>
            </a>
            <div class="more-options text-right show-on-hover">
              <a *ngIf="tableMeta.displayCreateMenu && (tableMeta.checkCanCreateOrderProperty ? rowData.canCreateOrder: true)"
                class="div-inline no-text-decoration" (click)="onCreateNewOrderClick(rowData)"
                pTooltip="{{'vbeiCreateNewOrder' | translate}}" tooltipStyleClass="create-new-order">
                <i class="ei ei-cart-plus ei-16"></i>
              </a>
              <a *ngIf="tableMeta.displayEditMenu" class="div-inline no-text-decoration m-l-16"
                (click)="onSelectingRow(rowData)" pTooltip="{{'vbeiEdit' | translate}}">
                <i class="ei ei-pencil ei-16"></i>
              </a>
              <a *ngIf="tableMeta.displayScheduleEditCalendar" class="div-inline no-text-decoration m-l-16"
                (click)="onEditScheduleButtonClick(rowData)" pTooltip="{{'vbeiEdit' | translate}}" [class.disabled-link]="rowData.status !== 'Active'">
                <i class="ei ei-calendar-empty ei-16"></i>
              </a>
              <a *ngIf="tableMeta.displayDeleteMenu && (tableMeta.checkCanDeleteOrderProperty ? rowData.canBeDeleted: true)"
                class="div-inline no-text-decoration m-l-16" (click)="deleteTableRow(rowData)"
                [pTooltip]="toolTipTextForDelete | translate">
                <i class="ei ei-trash2 ei-16"></i>
              </a>
            </div>
          </div>
          <div class="table-fields-option m-b-auto" *ngIf="showLoadingKebab">
            <i class="ei ei-refresh ei-16 rotating"></i>
          </div>
        </td>
        <td *ngIf="tableMeta.displaySplitMenu">
          <div *ngIf="!rowData['isHidden']" class="table-fields-option m-b-auto">
            <p-splitButton class="p-splitbutton-compressed p-splitbutton-left" icon="ei ei-kebab-more ei-16"
              [model]="splitOptions" menuStyleClass="fav-sample-split-options" (click)="onFocusRow(rowData)"
              appendTo="body">
            </p-splitButton>
          </div>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="summary">
      <div class="flex-body align-items-center">
        <span>{{noOfSelectedTableRows}} {{'vbeiProductSelected' | translate}}</span>
        <span class="divider m-r-24 m-l-24"></span>
        <a class="anchor" (click)="onMultipleDelete()">
          <i class="ei ei-trash2 ei-16"></i>&nbsp;<span>{{'vbeiDelete'|translate}}</span>
        </a>
      </div>
    </ng-template>

  </p-table>

  <p-paginator appCustomPaginator dropdownAppendTo="body" *ngIf="!tableMeta.hidePagination && totalRecords >= 10"
    [rows]="paginationState.rows" [first]="paginationState.first" [totalRecords]="totalRecords"
    [rowsPerPageOptions]="[10,20,30]" (onPageChange)="paginate($event)"
    [pageLinkSize]="math.ceil(totalRecords / 10)">
  </p-paginator>
  <div class="invalid-msg" *ngIf="checkValidation()">
    {{emptyGridErrorMessage | translate}}
  </div>
</div>

<!-- Enable context menu: Uncomment below code -->
<!-- <p-contextMenu #gridContext [hidden]="!tableMeta.displayContextMenu" [model]="contextMenuOptions" appendTo="body">
</p-contextMenu> -->